import { useLoaderData as useLoaderDataBase } from "react-router-dom";

export const useLoaderData = <T = unknown>(): T => {
  return useLoaderDataBase() as T;
};
